module.exports = __webpack_public_path__ + "static/800X450-5696b6c29c618761f3f531d1bf090a53.jpg";